import { EngineId } from 'features/Layouts/Layout/Vendors/Cludo/cludoHelpers';
import { swrAxiosGetFetcher } from 'helpers/swrAxiosFetcher';
import useSWR from 'swr';

export const cludoTagsName = 'tags';
export const cludoTypesName = 'types';
export interface UseCludoProps {
	engineId: EngineId;
	/** groupId is theme + '-' + the id of the catalogpage */
	groupId: string;
	query?: string;
	sort?: 'date' | 'id' | 'title' | 'default'; // default is accomplished by not passing a sorting value
	category?: 'documents';
	tags?: string[];
	types?: string[];
	limit?: number;
	dates?: {
		startDate: string;
		endDate: string;
	};
	operator?: 'and' | 'or';
}

export const transformCludoData = (data, category = null): Models.CatalogListItem[] | Models.DocumentCatalogListItem[] => {
	return data?.TypedDocuments.map((page) => {
		const { Title, Description, Url, ArticleImage, ArticleDate, ArticleId, ArticleExpirationDate, ArticleTags, ArticleTypes } = page.Fields ?? {};

		if (category === 'documents') {
			const listItem: Models.DocumentCatalogListItem = {
				heading: Title?.Value ? Title.Value : null,
				teaser: ArticleId?.Value ? (Description?.Values[0] ? Description.Values[0] : null) : null, // No need when catalog is in catalog
				number: ArticleId?.Value ? ArticleId.Value : null,
				link: {
					url: Url?.Value ? Url.Value : null,
					children: Title?.Value ? Title.Value : null,
				},
				date: ArticleDate?.Value ? ArticleDate.Value : null,
			};
			return listItem;
		}
		const listItem: Models.CatalogListItem = {
			heading: Title?.Value ? Title.Value : null,
			link: {
				url: Url?.Value ? Url.Value : null,
				name: Title?.Value ? Title.Value : null,
			},
			teaser: Description?.Values[0] ? Description?.Values[0] : null,
			image: ArticleImage?.Value
				? {
						url: ArticleImage?.Value,
						altText: '',
				  }
				: null,
			date: ArticleDate?.Value ? ArticleDate.Value : null,
			expirationDate: ArticleExpirationDate?.Value ? ArticleExpirationDate.Value : null,
			tags: Array.isArray(ArticleTags?.Values)
				? ArticleTags.Values.map((tag) => {
						return { name: tag };
				  })
				: null,
			types: ArticleTypes?.Values ? ArticleTypes.Values : null,
		};
		return listItem;
	});
};

export const useCludo = ({
	engineId,
	groupId,
	query = '*',
	sort = 'date',
	category,
	tags,
	types,
	limit = 10000,
	operator = 'and',
	dates,
}: UseCludoProps) => {
	const { data, error, isLoading, isValidating } = useSWR(
		`/api/search/${engineId}?
		${groupId && 'group=' + groupId + '&'}query=${query}${sort === 'default' ? '' : `&sort=${sort}`}
		${tags !== undefined ? '&tags=' + JSON.stringify(tags) : ''}
		${types !== undefined ? '&types=' + JSON.stringify(types) : ''}&operator=${operator}&limit=${limit}
		${dates ? '&startDate=' + dates.startDate + '&endDate=' + dates.endDate : ''}`,
		swrAxiosGetFetcher,
	);

	const results = transformCludoData(data, category);

	return {
		results: results,
		isLoading,
		isValidating,
		isError: error,
	};
};
